import type { EditorPlugin } from '../interfaces/editor-plugin';
import type { FabricPluginName } from '../plugins/plugin-name';
import type { FabricEditor } from './fabric-editor';

export class PluginRegistry {
  private readonly installed: EditorPlugin[] = [];
  private readonly names = new Set<FabricPluginName>();

  install(editor: FabricEditor, plugin: EditorPlugin): void {
    if (this.names.has(plugin.name)) {
      throw new Error(`Plugin "${plugin.name}" is already installed.`);
    }
    plugin.install(editor);
    this.installed.push(plugin);
    this.names.add(plugin.name);
  }

  disposeAll(editor: FabricEditor): void {
    for (let i = this.installed.length - 1; i >= 0; i--) {
      const plugin = this.installed[i];
      try {
        plugin.dispose?.(editor);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(`[fabric-editor] plugin "${plugin.name}" dispose threw:`, err);
      }
    }
    this.installed.length = 0;
    this.names.clear();
  }

  has(name: FabricPluginName): boolean {
    return this.names.has(name);
  }
}
